























































































import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';
import CoIcon from '../../Atoms/co-icon/CoIcon.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoInput from '../co-input/CoInput.vue';
import CoLoadingIndicator from '@/components/Atoms/co-loading-indicator/coLoadingIndicator.vue';

// Item represents a single item in the selector
interface Item {
    Name: string;
    Value: string | number | boolean | null | undefined | object;
    Disabled: boolean;
}

export default {
    name: 'CoSelect',
    components: { CoIcon, CoText, CoTippy, CoInput, CoLoadingIndicator },
    props: {
        value: {
            type: [String, Number, Boolean, Object, null, undefined],
            default: null,
        },
        items: {
            type: Array,
            default: () => [] as Item[],
        },
        minWidth: {
            type: Boolean,
            default: false,
        },

        variant: {
            type: String,
            default: 'default',
            validator: (value: string) => ['default', 'outline', 'grey'].includes(value),
        },
        placeholder: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: Boolean,
            default: true,
        },
        iconPosition: {
            type: String,
            default: 'right',
            validator: (value: string) => ['left', 'right'].includes(value),
        },
        // if set to true, the select will select the first item in the list if no value is set
        // (if no value is set and this is false, the select will be empty)
        selectFirstItem: {
            type: Boolean,
            default: true,
        },
        tippyOptions: {
            type: Object,
            default: () => ({}),
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            triggerId: null,
            selectedItem: {} as Item,
            selectOpen: false,
            selectedNative: null,
            isMobileDevice: navigator && navigator.userAgent && navigator.userAgent.match(/iPad|iPhone|Android/i),
            defaultStyles: {
                cursor: 'pointer !important',
                background: 'transparent !important',
                border: '1px solid var(--c-black) !important',
                color: 'var(--c-black) !important',
            },
            disabledStyles: {
                cursor: 'not-allowed !important',
                background: 'var(--c-lightgrey) !important',
                border: '1px solid var(--c-lightgrey) !important',
                color: 'var(--c-darkgrey) !important',
            },
            greyStyles: {
                cursor: 'pointer !important',
                background: 'var(--c-midgrey) !important',
                borderColor: 'var(--c-midgrey) !important',
                color: 'var(--c-black) !important',
            },
        };
    },
    watch: {
        value(newValue) {
            if (newValue && this.items.length > 0) {
                this.selectedItem = this.items.find((item) => item.Value === newValue.Value);
            } else if (this.items.length > 0) {
                this.selectedItem = this.items.find((item) => item.Value === newValue.Value);
            } else {
                this.selectedItem = null;
            }
        },
        items(newValue) {
            if (this.value && newValue.length > 0) {
                this.selectedItem = newValue.find((item) => item.Value === this.value.Value);
            } else if (newValue.length > 0 && this.selectFirstItem) {
                this.selectedItem = newValue[0];
            } else {
                this.selectedItem = null;
            }
        },
        disabled(newValue) {
            if (newValue) {
                this.$refs.selectTippy?.tippyInstance.disable();
            } else {
                this.$refs.selectTippy?.tippyInstance.enable();
            }
        },
    },
    computed: {
        classes() {
            return {
                grey: this.variant === 'grey',
                outline: this.variant === 'outline',
                'with-min-width': this.minWidth,
                disabled: this.disabled,
            };
        },
        triggerStyles() {
            if (this.disabled) return this.disabledStyles;
            switch (this.variant) {
                case 'grey':
                    return this.greyStyles;
                default:
                    return this.defaultStyles;
            }
        },
        placeholderLocal() {
            return this.placeholder || this.$t('labels.select');
        },
    },
    created() {
        this.triggerId = `trigger-${this._uid}`;
        if (this.items.length > 0 && this.value) {
            this.selectedItem = this.items.find((item) => item.Value === this.value.Value);
        } else if (this.items.length > 0 && this.selectFirstItem) {
            this.selectedItem = this.items[0];
        }
    },
    mounted() {
        if (this.value && this.items.length > 0) {
            this.selectedItem = this.items.find((item) => item.Value === this.value.Value);
        } else if ((!this.placeholder || this.placeholder === '') && this.items[0]) {
            [this.selectedItem] = this.items;
        }
    },
    methods: {
        openSelectItems(tippyInstance) {
            if (this.disabled) {
                return;
            }
            // Use native selects (which pop up large native UIs to go through the options ) on iOS/Android
            if (this.isMobileDevice) {
                const new_event = new MouseEvent('mousedown');
                this.$refs.nativeSelect.dispatchEvent(new_event);
            }
        },
        select(item) {
            this.selectedItem = item;
            this.$emit('select', item);
            this.selectOpen = false;
            // close tippy dropdown
            this.$refs.selectTippy?.hide();
            // emit input event to enable usage of v-model
            this.$emit('input', item);
        },
        nativeSelectHandler() {
            if (this.selectedNative) {
                this.select(this.selectedNative);
            }
        },
    },
};
